import { HomeRoute, PlanRoute } from '@/utils/enum';
import { QueryResource } from '@/api/common/common';
import { QueryUserInfo } from '@/api/user';
import store from '../store';

/**获取用户基本信息 */
function queryUserInfo() {
  return new Promise((resolve) => {
    QueryUserInfo().then(res => {
      if (res.code == 200) {
        store.commit('changeUserInfo', res.data);
        resolve(res);
      }else{
        resolve(res);
      }
    }).catch(err=>{
      resolve(err);
    })
  })
}
/**递归处理菜单 */
function handleMenu(data) {
  data.forEach((item, index) => {
    var obj = {
      label: item.name,
      value: item.url.slice(1),
      permission: item.url.slice(1),
      children: item.children || [],
      show: true,
      path: item.url
    };
    data[index] = obj;
    if (item.children && item.children.length > 0) {
      handleMenu(item.children);
    }
  })
  return data;
};
/**获取资源权限 */
export function queryResource() {
  return new Promise((resolve) => {
    QueryResource({ appCode: process.env.VUE_APP_APP_CODE }).then(res => {
      if (res.code == 200) {
        var navList = handleMenu(res.data.horizontalMenuList);
        var menuList = handleMenu(res.data.menuList);
        navList.unshift(HomeRoute);
        navList.push(PlanRoute);
        var magSysList = menuList.find(item => {
          return item.value == 'magSys';
        });
        if (magSysList) {
          magSysList.show = false;
          magSysList = magSysList.children;
        }
        store.commit('changeMagSysList', magSysList || []);
        store.commit('updateNavList', navList);
        store.dispatch('setPermissions', res.data.permissions);
        queryUserInfo().then(()=>{
          resolve([...navList, ...menuList]);
        });
      } else {
        resolve([]);
      }
    }).catch(err => {
      resolve();
    })
  })
}